module.exports = __webpack_public_path__ + "static/media/comment_icon.5ec1e444.svg";